import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseVozidlaSearch } from '@/modules/vozidla/helpers';

/** List-filter mirror + the `?id_zakaznika=N` round-trip from "Nový zákazník". */
function parseDetailSearch(input: Record<string, unknown>) {
  const out: ReturnType<typeof parseVozidlaSearch> & { id_zakaznika?: number } =
    parseVozidlaSearch(input);
  const z = input.id_zakaznika;
  if (typeof z === 'number' && Number.isFinite(z) && z > 0) out.id_zakaznika = z;
  if (typeof z === 'string' && /^\d+$/.test(z)) out.id_zakaznika = Number(z);
  return out;
}

const VozidloDetail = lazy(() =>
  import('@/modules/vozidla/VozidloDetail').then((m) => ({ default: m.VozidloDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/$id',
  component: () => (
    <Suspense fallback={null}>
      <VozidloDetail />
    </Suspense>
  ),
  validateSearch: parseDetailSearch,
});
